<template>
    <div class="card-container">
        <el-button type="default" class="button-size" @click="$router.go(-1)">返回上一级</el-button>
        <common-table :data="tableData" ref="commonTable" :isShow="false">
            <el-table-column prop="nickName" label="会员名称" show-overflow-tooltip></el-table-column>
            <el-table-column prop="phoneNumber" label="会员电话" show-overflow-tooltip></el-table-column>
            <el-table-column prop="balAmt" label="返佣金额(元)" show-overflow-tooltip>
                <template slot-scope="scope">
                    <p>{{toDoubleThousands(scope.row.operationAmt *100 / 10000)}}</p>
                </template>
            </el-table-column>
        </common-table>
    </div>
</template>

<script>
    import CommonTable from 'components/common/CommonTable'

    import FinanceService from 'service/FinanceService'
    import privateKey from 'service/constant/privateKey';
    import {encrypt, urlEncode, objKeySort} from "common/js/common-utils";
    import {loadMixin, dialogMixin} from "mixin";
    import {mapGetters} from 'vuex'

    export default {
        name: "MemberLevelDetail",
        components:{
            CommonTable
        },
        data() {
            return {
                tableData:[{}],
                memberId:'',
            }
        },
        mixins: [loadMixin, dialogMixin],
        mounted(){
            this.memberId = this.$route.params.id;
            this.getList();
        },
        computed:{
            ...mapGetters(['serverType', 'tatId', 'userId']),
        },
        methods:{
            getList() {
                const params = {
                    tranId: this.memberId,
                };

                this.doLoad(FinanceService.getMemUpDtl, params, res => {
                    this.doCheck(res, res => {
                        const result = res.contents;
                        this.tableData = result;
                        console.log('2',result)
                    });
                }, '信息获取失败')
            },
        }
    }
</script>

<style scoped>

    .button-size{
        width: 120px;
        margin-bottom: 30px;
    }
</style>



// WEBPACK FOOTER //
// src/view/page/FinanceManage/MemberLevelDetail.vue